<template>
  <div
    data-testid="app-install-links"
    class="flex-col justify-start items-start gap-3 inline-flex"
  >
    <div class="text-stone-700 text-base font-semibold leading-none">
      {{ $t("모바일 앱") }}
    </div>
    <div class="flex flex-wrap items-center gap-2">
      <a
        :href="IOS_APP_STORE_URL"
        target="_blank"
        rel="noopener noreferrer"
        :aria-label="$t('App Store에서 설치')"
        class="inline-flex rounded-md focus:outline-none focus:ring-2 focus:ring-stone-500 focus:ring-offset-2"
      >
        <img
          :src="appStoreBadge"
          :alt="$t('Download on the App Store')"
          class="block h-10 w-auto"
        />
      </a>
      <a
        :href="GOOGLE_PLAY_STORE_URL"
        target="_blank"
        rel="noopener noreferrer"
        :aria-label="$t('Google Play에서 설치')"
        class="inline-flex rounded-md focus:outline-none focus:ring-2 focus:ring-stone-500 focus:ring-offset-2"
      >
        <img
          :src="googlePlayBadge"
          :alt="$t('Get it on Google Play')"
          class="block h-10 w-auto"
        />
      </a>
    </div>
  </div>
</template>

<script setup>
import appStoreBadge from '@/assets/app-stores/download-on-the-app-store.svg'
import googlePlayBadge from '@/assets/app-stores/get-it-on-google-play.png'

const IOS_APP_STORE_URL = 'https://apps.apple.com/kr/app/chromaworks/id6479591889';
const GOOGLE_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.evanskim.chromaworks';
</script>
